<template>
    <div>
        <Head title="Створити правило бонусу"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" :href="$route('bonus-rules.index')">
                Правила бонусу
            </Link>
            <span class="text-indigo-400 font-medium"> /</span> Створення
        </h1>
        <div class="max-w-lg bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name"
                                class="pb-8 pr-6 w-full" label="Назва"/>
                    <text-input v-model="form.min_amount" :error="form.errors.min_amount"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Мінімальна загальна сума замовлень (грн)"
                                type="number" min="0" step="0.01"/>
                    <text-input v-model="form.bonus_percent" :error="form.errors.bonus_percent"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Бонус (%)"
                                type="number" min="0" max="100" step="0.01"/>
                    <checkbox v-model="form.is_active" :error="form.errors.is_active"
                              class="pb-8 pr-6 w-full" label="Активне"/>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Checkbox from '@/Shared/Checkbox'

export default {
    components: { Head, Link, LoadingButton, TextInput, Checkbox },
    layout: Layout,
    data() {
        return {
            form: this.$inertia.form({
                name:          '',
                min_amount:    0,
                bonus_percent: '',
                is_active:     true,
            }),
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('bonus-rules.store'))
        },
    },
}
</script>
